import logo from './logo.png';
import './App.css';
import { useEffect, useRef, useState } from "react";

const statsData = [
  { label: "Years Experience", target: 8, suffix: "" },
  { label: "Students", target: 400, suffix: "" },
];


function App() {
  
  const [counts, setCounts] = useState(statsData.map(() => 0));
  const hasAnimated = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.querySelector(".stats-section");
      if (!section) return;
      const rect = section.getBoundingClientRect();
      if (!hasAnimated.current && rect.top < window.innerHeight * 0.75) {
        hasAnimated.current = true;
        statsData.forEach((stat, index) => {
          let start = 0;
          const speed = 50;
          const increment = stat.target / speed;

          const updateCount = () => {
            start += increment;
            if (start < stat.target) {
              setCounts((prev) =>
                prev.map((v, i) => (i === index ? Math.ceil(start) : v))
              );
              requestAnimationFrame(updateCount);
            } else {
              setCounts((prev) =>
                prev.map((v, i) => (i === index ? stat.target : v))
              );
            }
          };
          updateCount();
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // in case already visible on load

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const images = [
  "/images/screenshot_1.jpg",
  "/images/screenshot_2.jpg",
  "/images/screenshot_3.jpg",
  "/images/screenshot_4.jpg"
];

const [currentIndex, setCurrentIndex] = useState(0);

  const prevImage = () => {
    setCurrentIndex((currentIndex - 1 + images.length) % images.length);
  };

  const nextImage = () => {
    setCurrentIndex((currentIndex + 1) % images.length);
  };
  return (
    <div className="App">
      <header className="App-header">
        <div className="sections">
          <img src={logo} className="App-logo" alt="logo" />
          <h1><span>Revealing the proven strategy that helps traders move from inconsistent results to <b>confident, consistent profits.</b></span></h1>
          <h2 className="stars">★★★★★</h2>
          <p>Be part of 85% of students who’ve gone FULL TIME in Trading!</p>
          {
            /*
          <video width="640" height="360" controls autoPlay muted loop playsInline style={{ width: "100%", maxWidth: "800px", height: "auto" }}>
            <source src="videos/home_page.mp4" type="video/mp4"></source>
            Your browser does not support the video tag.
          </video>
            */
          }
          <br></br>
          <a href="https://wa.me/601117608518?text=Hello%2C%20I%20am%20interested%20in%20your%20services%21" target="_blank" rel="noopener noreferrer" class="whatsapp-btn">
            APPLY NOW
          </a>
        </div>
        <hr></hr>
        <div className="sections">
          <h2>WHO IS THIS Mentorship FOR?</h2>
          <ul class="tick-list">
            <li><span>Individuals ready to start with at least <b>$300 in trading capital</b></span></li>
            <li><span>Those who want to <b>claim a free $300 trading credit</b> to kickstart their journey</span></li>
            <li><span>Traders who are tired of inconsistency and ready to <b>scale their profits beyond $5,000/month</b></span></li>
            <li><span>Ambitious learners willing to <b>invest in mentorship</b> to fast-track their growth</span></li>
            <li><span>Anyone looking to <b>master discipline, risk management, and a proven strategy</b></span></li>
            <li><span>Serious individuals committed to building <b>long-term, consistent trading success</b></span></li>
          </ul>
        </div>
        <hr></hr>
        <div className="sections">
          <h2>WHAT DOES THIS MENTORSHIP INCLUDE?</h2>
          <ul class="tick-list">
            <li><span><b>Exclusive Trade Signals</b> – Get direct access to live every trade executed <b style={{color: "red"}}>( Target Price and Stop Loss )</b></span></li>
            <li><span><b>Private Trading Community</b> – Network and learn inside the Trading Inner Circle.</span></li>
            <li><span><b>Risk Management & Trading Psychology</b> – Master emotional control and capital management for long-term success.</span></li>
            <li><span><b>Direct Priority Access to chat with (Professional Trader)</b> – Skip the guesswork and get real insights straight from a pro.</span></li>
          </ul>
        </div>
          
        <hr></hr>
          <div className="stats-section" style={{ display: "flex", justifyContent: "center", gap: "3rem", flexWrap: "wrap", textAlign: "center", margin: "3rem auto" }}>
            {statsData.map((stat, index) => (
              <div key={index} className="stat">
                <div className="stat-number" style={{ fontSize: "2.5rem", fontWeight: "700", color: "#22c55e" }}>
                  {counts[index].toLocaleString()}{stat.suffix}
                </div>
                <div className="stat-label" style={{ fontSize: "1rem", color: "#555", marginTop: "0.3rem" }}>
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        <hr></hr>
        <div className="sections">
          <h2>WHY YOU’LL SUCCEED WITH US</h2>
          <p>At <b>Wilson Trading Academy</b>, success isn’t a maybe — it’s the standard.<br></br>You’ll learn the <b>exact strategies</b> used by six-figure traders to grow consistent profits week after week.</p>
          <p>Our mentorship gives you <b>proven risk management, emotional mastery</b>, and a <b>clear system</b> that removes the guesswork — so you can focus on winning trades.</p>
          <p>With the <b>right guidance and strategy</b>, your trading results stop depending on luck… and start compounding by strategy trading plan.</p>
          
          <a href="https://wa.me/601117608518?text=Hello%2C%20I%20am%20interested%20in%20your%20services%21" target="_blank" rel="noopener noreferrer" class="whatsapp-btn">
            APPLY NOW
          </a>
        </div>
        <hr></hr>
        <div className="sections">
          <h2>Personal & Client Results</h2>
          <p>Real screenshots of progress and wins shared directly by Wilson Trading's students.</p>
          
          <div className="gallery">
            <div className="gallery-main-container">
              <button className="arrow left" onClick={prevImage}>&#8592;</button>
              <img
                src={images[currentIndex]}
                alt={`Photo ${currentIndex + 1}`}
                className="gallery-main"
              />
              <button className="arrow right" onClick={nextImage}>&#8594;</button>
            </div>

            <div className="gallery-thumbs">
              {images.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt={`Thumbnail ${i + 1}`}
                  className={i === currentIndex ? "thumb active" : "thumb"}
                  onClick={() => setCurrentIndex(i)}
                />
              ))}
            </div>
          </div>
        </div>
        
        <a href="https://www.instagram.com/wilson_trading8" target="_blank" rel="noopener noreferrer" class="instagram-float">
          <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" />
        </a>
        <a 
          href="https://wa.me/601117608518?text=Hello%2C%20I%20am%20interested%20in%20your%20services%21" 
          target="_blank" 
          rel="noopener noreferrer"
          class="whatsapp-float"
        >
          <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" />
        </a>
      </header>
    </div>
  );
}

export default App;
